import { client } from './client'
import { normalizeWorldCreditsResponse, createResponseByProductId, createSingleProductResponse } from './normalize'

const fetchWelcomeOffer = async () => {
  try {
    let response = await client.get('/v1/product/welcomeOffer')
    return response.data
  } catch (error) {
    throw error
  }
  /* eslint-disable */
  // !for-testing
  // console.log('api/sales/index.js - fetchWelcomeOffer in testing-mode')
  // AccountWelcomeOfferWorldCredits
  // return {"productId":1000,"name":"World Credits","priority":0,"offeredAsSubscription":false,"subscriptionCompulsory":false,"upSell":false,"productType":"payg","categories":["World Credit"],"productPrice":{"currencyId":"EUR","amount":5.0000,"formatted":"5 €"},"purchasable":true,"autotopupable":false,"autotopupLimit":1.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":'NG',"targetedCountries":[],"validForPeriod":0,"minutes":200,"discountDays":0,"linkedProductId":null}
  // AccountWelcomeOfferWorldCredits
  // return {"productId":1000,"name":"World Credits","priority":0,"offeredAsSubscription":false,"subscriptionCompulsory":false,"upSell":false,"productType":"payg","categories":["World Credit"],"productPrice":{"currencyId":"EUR","amount":5.0000,"formatted":"5 €"},"purchasable":true,"autotopupable":false,"autotopupLimit":1.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":null,"targetedCountries":[],"validForPeriod":0,"minutes":0.0,"discountDays":0,"linkedProductId":null}
  // AccountWelcomeOfferUnlimited
  // return {"productId":8505,"name":"Mexico Unlimited 30 days","priority":0,"offeredAsSubscription":true,"subscriptionCompulsory":true,"upSell":false,"productType":"unlimited","categories":["Unlimited Trial"],"productPrice":{"currencyId":"EUR","amount":2.5000,"formatted":"2,50 €"},"subscription":{"subscriptionPrice":{"currencyId":"EUR","amount":2.5000,"formatted":"2,50 €"}},"purchasable":true,"autotopupable":false,"autotopupLimit":0.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":"MX","targetedCountries":["MX"],"validForPeriod":30,"minutes":0.0,"discountDays":7,"linkedProductId":null}
  // AccountWelcomeOfferFreeUnlimited
  // return {"productId":8652,"name":"US Unlimited Free","priority":0,"offeredAsSubscription":false,"subscriptionCompulsory":false,"upSell":false,"productType":"unlimited","categories":["Unlimited Trial"],"productPrice":{"currencyId":"USD","amount":0.0000,"formatted":"0¢"},"purchasable":true,"autotopupable":false,"autotopupLimit":0.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":"US","targetedCountries":["US"],"validForPeriod":30,"minutes":0.0,"discountDays":0,"linkedProductId":null}
  // AccountWelcomeOfferGlobalUnlimited
  // return {"productId":8653,"name":"Global Unlimited","priority":0,"offeredAsSubscription":true,"subscriptionCompulsory":true,"upSell":false,"productType":"unlimited","categories":["Global Unlimited Trial"],"productPrice":{"currencyId":"EUR","amount":12.0000,"formatted":"12 €"},"subscription":{"subscriptionPrice":{"currencyId":"EUR","amount":12.0000,"formatted":"12 €"}},"purchasable":true,"autotopupable":false,"autotopupLimit":0.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":"AD","targetedCountries":["AD","AR","AT","AU","BE","BM","BN","BR","CA","CH","CL","CN","CO","CY","CZ","DE","DK","ES","FI","FR","GB","GF","GP","GR","GU","HK","HU","ID","IE","IL","IN","IS","IT","JP","KR","LU","MN","MQ","MT","MX","MY","NL","NO","NZ","PE","PL","PR","PT","RO","SE","SG","SK","TH","TW","US","VI"],"validForPeriod":30,"minutes":0.0,"discountDays":7,"linkedProductId":null}
  // AccountWelcomeOfferLimited
  // return {"productId":6509,"name":"Bangladesh - 450 mins","priority":0,"offeredAsSubscription":true,"subscriptionCompulsory":true,"upSell":false,"productType":"deal","categories":["Limited Trial"],"productPrice":{"currencyId":"EUR","amount":12.0000,"formatted":"12 €"},"subscription":{"subscriptionPrice":{"currencyId":"EUR","amount":12.0000,"formatted":"12 €"}},"purchasable":true,"autotopupable":false,"autotopupLimit":0.0,"allowedPurchaseLimit":5,"defaultAutotopupProduct":false,"targetedCountry":"BD","targetedCountries":["BD"],"validForPeriod":30,"minutes":450.0,"discountDays":7,"linkedProductId":null}
  // AccountWelcomeOfferWelcomeOffer
  // return {"productId":3718,"name":"Guatemala Welcome Offer 30 min","priority":0,"offeredAsSubscription":false,"subscriptionCompulsory":false,"upSell":false,"productType":"deal","categories":["Acquisition"],"productPrice":{"currencyId":"EUR","amount":1.0000,"formatted":"1 €"},"purchasable":true,"autotopupable":false,"autotopupLimit":0.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":"GT","targetedCountries":["GT"],"validForPeriod":30,"minutes":30.0,"discountDays":0,"linkedProductId":null}
  // AccountWelcomeOfferMembership - removed
  // return {"productId":1600,"name":"Rebtel Plus membership trial","priority":0,"offeredAsSubscription":true,"subscriptionCompulsory":true,"upSell":false,"productType":"membership","categories":["Membership World Credit trial"],"productPrice":{"currencyId":"USD","amount":5.0000,"formatted":"$5"},"subscription":{"subscriptionPrice":{"currencyId":"USD","amount":3.0000,"formatted":"$3"}},"purchasable":true,"autotopupable":false,"autotopupLimit":1.0,"allowedPurchaseLimit":null,"defaultAutotopupProduct":false,"targetedCountry":"CM","targetedCountries":["CM","CU","GH","NG"],"validForPeriod":30,"minutes":0.0,"discountDays":30,"linkedProductId":null}
  /* eslint-enable */
}

const fetchWorldCredits = async (currencyRequest) => {
  try {
    let response = await client.post('/v1/product/payg', {
      country: null,
      currency: currencyRequest.currencyId,
      locale: 'en-US',
      region: null
    })
    let ourResponse = normalizeWorldCreditsResponse(response.data)
    return ourResponse.products
  } catch (error) {
    throw error
  }
}

const fetchUnlimitedProducts = async () => {
  try {
    let response = await client.get('/v2/products?viewFilter=UnlimitedView')
    return createResponseByProductId(response.data.products)
  } catch (error) {
    throw error
  }
}

const fetchDeals = async () => {
  try {
    let response = await client.get('/v2/products?productType=deal')
    return createResponseByProductId(response.data.products)
    // return response.data.products
  } catch (error) {
    throw error
  }
}

const fetchProductById = async (id) => {
  try {
    let response = await client.get(`/v1/product/${id}`)
    return createSingleProductResponse(response.data.products[0])
  } catch (error) {
    throw error
  }
}

export {
  fetchWelcomeOffer,
  fetchWorldCredits,
  fetchUnlimitedProducts,
  fetchDeals,
  fetchProductById
}



// WEBPACK FOOTER //
// ./src/api/sales/index.js